import React from "react";
import FOG from "vanta/dist/vanta.fog.min";
import * as THREE from "three"; // Correctly import THREE

class VantaBackground extends React.Component {
  constructor() {
    super();
    this.vantaRef = React.createRef();
  }

  componentDidMount() {
    this.vantaEffect = FOG({
      el: this.vantaRef.current,
      THREE: THREE, // Ensure THREE is passed explicitly
      mouseControls: false,
      touchControls: false,
      gyroControls: false,
      minHeight: 200.0,
      minWidth: 200.0,
      highlightColor: 0x777777,
      midtoneColor: 0x0,
      lowlightColor: 0x0,
      baseColor: 0x0,
      blurFactor: 0.61,
      speed: 1.2,
      zoom: 2.5,
    });
  }

  componentWillUnmount() {
    if (this.vantaEffect) this.vantaEffect.destroy();
  }

  render() {
    return (
      <div
        ref={this.vantaRef}
        style={{
          width: "100%",
          height: "100vh",
          position: "fixed",
          zIndex: -1, // Default z-index
        }}
      ></div>
    );
  }
}

export default VantaBackground;
